import { createFileRoute } from "@tanstack/react-router";

import SetlistsCreateUpdate from "@/features/gigs/SetlistsCreateUpdate";
import SideNavLayout from "@/layouts/SideNavLayout";
import { GigsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/gigs/setlists/update/$id")({
  component: () => (
    <SideNavLayout menu={<GigsMenu />}>
      <SetlistsCreateUpdate key="update" />
    </SideNavLayout>
  ),
});
